export default {
  zh: {
    accountOverview: '账户总览',
    settings: '设置',
    inviteRecord: '邀请记录',
    rechargeRecords: '充值记录',
    affiliate: '联盟推广',
    notification: '动态消息',
    download: '下载客户端',
    faq: '常见问题',
    device_manage: '设备管理'
  },
  en: {
    accountOverview: 'Account',
    settings: 'Settings',
    inviteRecord: 'Invitation Records',
    affiliate: 'Affiliate',
    rechargeRecords: 'Purchase Records',
    notification: 'Notifications',
    download: 'Download',
    faq: 'FAQ',
    device_manage: 'Device Management'
  }
}



// WEBPACK FOOTER //
// ./src/components/leftSidebar/lang.js